
import Vue from "vue";
import { mapGetters } from "vuex";
import { APP_AI_ASSESSMENT_LISTING } from "@/store/modules/recruiter/constants";
import { AppAiAssessmentListing } from "@/store/modules/recruiter/interfaces";
import moment from "moment";

export default Vue.extend({
  name: "AiSelectedDatePicker",
  computed: {
    ...mapGetters("recruiter", {
      app_ai_assessment: APP_AI_ASSESSMENT_LISTING
    }),
    CurrentAiAssessment(): AppAiAssessmentListing {
      return this.app_ai_assessment();
    }
  },
  methods: {
    clear_dates() {
      this.CurrentAiAssessment.selected_dates = {
        date_filter: [],
        date_range_value: "",
        date_picker_menu: false
      };
      this.$emit("selected_dates", []);
    },
    async format_date_range(dates: string[]) {
      if (dates.length === 1)
        this.CurrentAiAssessment.selected_dates.date_range_value = moment(
          dates[0]
        ).format("DD MMM YYYY");
      else if (dates.length === 2) {
        this.CurrentAiAssessment.selected_dates.date_range_value =
          moment(dates[0]).format("DD MMM YYYY") +
          "  to  " +
          moment(dates[1]).format("DD MMM YYYY");
        this.CurrentAiAssessment.selected_dates.date_picker_menu = false;
        this.$emit("selected_dates", dates);
      }
    }
  }
});
